(() => {
  const root = document.querySelector('[data-rose]');
  if (!root || root.dataset.weddingInitialized) return;
  root.dataset.weddingInitialized = 'true';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;
  const overlay = document.createElement('div');
  overlay.className = 'tlr-petals';
  overlay.setAttribute('aria-hidden', 'true');
  const count = window.matchMedia('(max-width: 849px)').matches ? 16 : 24;
  for (let i = 0; i < count; i += 1) {
    const petal = document.createElement('span');
    petal.className = 'tlr-petal';
    petal.style.setProperty('--left', `${(i + Math.random()) / count * 100}%`);
    petal.style.setProperty('--size', `${10 + Math.random() * 9}px`);
    petal.style.setProperty('--drift', `${(Math.random() - 0.5) * 160}px`);
    petal.style.setProperty('--turn', `${180 + Math.random() * 390}deg`);
    petal.style.setProperty('--duration', `${6.5 + Math.random() * 2}s`);
    petal.style.setProperty('--delay', `${Math.random() * 2}s`);
    overlay.append(petal);
  }
  root.append(overlay);
  let timer;
  const cleanup = () => {
    clearTimeout(timer);
    overlay.remove();
    reducedMotion.removeEventListener('change', onMotionChange);
    window.removeEventListener('pagehide', cleanup);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
  };
  const onMotionChange = event => { if (event.matches) cleanup(); };
  const onSectionUnload = event => { if (event.target.contains(root)) cleanup(); };
  reducedMotion.addEventListener('change', onMotionChange);
  window.addEventListener('pagehide', cleanup, {once: true});
  document.addEventListener('shopify:section:unload', onSectionUnload);
  timer = setTimeout(cleanup, 11500);
})();
